import React, { useContext, useState } from "react";
import { createPortal } from "react-dom";
import "./ChangeLogPop.scss";
import { changeLog } from "../../ChangeLog";

const ChangeLogPop = (props) => {
    const formatDate = (value) => {
        if (!value) return "";

        const [year, month, day] = value.split("-").map(Number);
        if (!year || !month || !day) return value;

        const date = new Date(Date.UTC(year, month - 1, day));

        return new Intl.DateTimeFormat("en-GB", {
            day: "2-digit",
            month: "long",
            year: "numeric",
        }).format(date);
    };

    return (
        <>
            {props.shown && createPortal(
                <div className="change-log-pop-canceller" onClick={props.hideFunc}></div>,
                document.body
            )}
            {createPortal(
                <div className={'change-log-pop-container' + (props.shown ? '' : ' change-log-pop-hidden')} onClick={props.hideFunc}>
                    <div className="fl-column compact">
                        <h4 className="change-log-title">Change Log</h4>
                        {changeLog.map((entry) => (
                            <div className="change-log-entry-panel" key={entry.version}>
                                <div className="entry-header-container">
                                    <div className="entry-version">v{entry.version}</div>
                                    <div className="entry-date">{formatDate(entry.date)}</div>
                                </div>
                                <ul>
                                    {entry.changes.map((change, index) => (
                                        <li key={index}>{change}</li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>,
                document.body
            )}
        </>
    );
};

export default ChangeLogPop;
